module.exports = __webpack_public_path__ + "img/prop1.84306ed7.png";